export const POLICY_SUMMARY = [
  {
    icon: 'fa-file-signature',
    title: 'Finalidad informada',
    description:
      'Los datos serán utilizados para las finalidades informadas al titular y permitidas por la legislación aplicable.',
  },
  {
    icon: 'fa-user-check',
    title: 'Control del titular',
    description:
      'El titular podrá conocer, actualizar, rectificar y solicitar la supresión de sus datos cuando corresponda.',
  },
  {
    icon: 'fa-lock',
    title: 'Información protegida',
    description:
      'Se aplicarán medidas administrativas, técnicas y organizacionales para proteger la información.',
  },
  {
    icon: 'fa-headset',
    title: 'Atención de solicitudes',
    description:
      'Las consultas y reclamos serán atendidos mediante los canales institucionales establecidos.',
  },
];
